import { Check, Copy } from 'lucide-react'

import { useCopyToClipboard } from '@/frontend/hooks/use-copy-to-clipboard'
import { cn } from '@/frontend/lib/utils'

/**
 * Small icon button that copies `value` to the clipboard, showing a brief
 * check-mark confirmation and a toast. `label` names the copied thing in the
 * toast and accessible label (e.g. "Email" → "Email copied", "Copy email").
 */
export function CopyButton({
  value,
  label,
  className,
  iconClassName = 'size-3.5',
}: {
  value: string
  label: string
  className?: string
  iconClassName?: string
}) {
  const { copied, copy } = useCopyToClipboard()

  return (
    <button
      type="button"
      onClick={() => copy(value, label)}
      aria-label={`Copy ${label.toLowerCase()}`}
      className={cn(
        'shrink-0 rounded p-1 text-muted-foreground transition-colors hover:text-foreground',
        className
      )}
    >
      {copied ? (
        <Check className={cn(iconClassName, 'text-success-fg')} />
      ) : (
        <Copy className={iconClassName} />
      )}
    </button>
  )
}
